export const firebaseConfig = {
    apiKey: "AIzaSyCdST1IZfAURDVX20OCjM8b6K7odHbQaQA",
    authDomain: "gitchat-bc8fa.firebaseapp.com",
    databaseURL: "https://gitchat-bc8fa.firebaseio.com",
    projectId: "gitchat-bc8fa",
    storageBucket: "gitchat-bc8fa.appspot.com",
    messagingSenderId: "645860967389",
    appId: "1:645860967389:web:a1d389aba6109a7bcbac34"
};